export const SkillConfig = [{
    name: "PROGRAMMING LANGUAGES",
    skillSets: [
        {
            skill: "C++",
            percent: 90
        }, {
           skill: "Python",
           percent: 85
        },{
            skill: "JavaScript",
            percent: 85
        }
    ]
},

    {
    name: "BACKEND",
    skillSets: [
        {
            skill: "NODE JS",
            percent: 75
        }
    ]
}, {
    name: "FRONTEND",
    skillSets: [
        {
            skill: "HTML / CSSS ",
            percent: 95
        }, {
            skill: "ANGULAR 8",
            percent: 90
        }
    ]
}, {
    name: "TOOLS & OTHERS",
    skillSets: [
        {
            skill: "Git",
            percent: 80
        },
        {
            skill: "AWS SERVICES",
            percent: 75
        },
    ]
}];